import styled from 'styled-components';

import { Translated } from '@/services/locale';
import { useTheme, Theme } from '@/services/theme';
import { breakpoints } from '@/shared/styles';

import { Typography } from '../../../Typography';

type Resource = {
  name: string;
  href: string;
  isExternal?: boolean;
};

export type Props = {
  title: string;
  resources: Resource[];
};

const StyledResourcesList = styled.ul`
  display: flex;
  flex-flow: row wrap;
  gap: 2rem 3rem;
  list-style-type: none;

  @media (min-width: ${breakpoints.mobileXL}px) {
    flex-flow: column nowrap;
  }
`;

const StyledLink = styled.a`
  color: ${({ $theme }: { $theme: Theme }) => $theme.colors.text.secondary};
  font-family: ${({ $theme }: { $theme: Theme }) => $theme.fonts.main};
  line-height: 1.6;
  text-decoration: underline solid transparent;
  text-underline-offset: 0.35em;
  transition: text-decoration-color 300ms;

  &:focus,
  &:hover {
    text-decoration-color: ${({ $theme }: { $theme: Theme }) => $theme.colors.text.primary};
  }
`;

const Resources: React.FC<Props> = ({ title, resources }) => {
  const { theme } = useTheme();

  return (
    <section>
      <Typography variant="h3" mb={2.4}>
        {title}
      </Typography>

      <StyledResourcesList>
        {resources.map(({ name, href, isExternal }) => (
          <li key={name}>
            <StyledLink
              href={href}
              target={isExternal ? '_blank' : undefined}
              rel={isExternal ? 'noreferrer' : undefined}
              $theme={theme}
            >
              <Translated>{name}</Translated>
            </StyledLink>
          </li>
        ))}
      </StyledResourcesList>
    </section>
  );
};

export { Resources };
